import { fromJS, List } from 'immutable';
import { isEmptyValue } from '../../../common/utils.jsx';
import { EMPTY_STRING } from '../../questionnaire.utils.jsx';
import ld from 'lodash';
import _ from '../../i18n.jsx';

const MALE = 'MALE';
const FEMALE = 'FEMALE';

/* relative internal names (used like id) */
const UNKNOWN_RELATION = 'other';
const MOTHER = 'mother';
const FATHER = 'father';
const SISTER = 'sister';
const BROTHER = 'brother';
const DAUGHTER = 'daughter';
const SON = 'son';
const MATERNAL_UNCLE = 'maternal_uncle';
const MATERNAL_AUNT = 'maternal_aunt';
const PATERNAL_UNCLE = 'paternal_uncle';
const PATERNAL_AUNT = 'paternal_aunt';
const COUSIN_MALE = 'cousin_male';
const COUSIN_FEMALE = 'cousin_female';
const NEPHEW = 'nephew';
const NIECE = 'niece';
const MATERNAL_GRANDMOTHER = 'maternal_grandmother';
const MATERNAL_GRANDFATHER = 'maternal_grandfather';
const PATERNAL_GRANDMOTHER = 'paternal_grandmother';
const PATERNAL_GRANDFATHER = 'paternal_grandfather';

/* Field names presented in config */
const FIELD_MOTHER = 'mother';
const FIELD_FATHER = 'father';
const FIELD_SIBLINGS = 'siblings';
const FIELD_CHILDREN = 'children';
const FIELD_MOTHER_SIBLINGS = 'mother_siblings';
const FIELD_FATHER_SIBLINGS = 'father_siblings';
const FIELD_COUSINS = 'cousins';
const FIELD_NEPHEWS = 'nephews';
const FIELD_MATERNAL_GRANDMOTHER = 'maternal_grandmother';
const FIELD_MATERNAL_GRANDFATHER = 'maternal_grandfather';
const FIELD_PATERNAL_GRANDMOTHER = 'paternal_grandmother';
const FIELD_PATERNAL_GRANDFATHER = 'paternal_grandfather';


export const relativesDescription = {
    [MOTHER]: { field: FIELD_MOTHER, gender: FEMALE, title: _('Mother'), isArray: false },
    [FATHER]: { field: FIELD_FATHER, gender: MALE, title: _('Father'), isArray: false },

    [SISTER]: { field: FIELD_SIBLINGS, gender: FEMALE, title: _('Sister'), isArray: true },
    [BROTHER]: { field: FIELD_SIBLINGS, gender: MALE, title: _('Brother'), isArray: true },

    [DAUGHTER]: { field: FIELD_CHILDREN, gender: FEMALE, title: _('Daughter'), isArray: true },
    [SON]: { field: FIELD_CHILDREN, gender: MALE, title: _('Son'), isArray: true },

    [MATERNAL_UNCLE]: { field: FIELD_MOTHER_SIBLINGS, gender: MALE, title: _(`Uncle (Mother's Brother)`), isArray: true },
    [MATERNAL_AUNT]: { field: FIELD_MOTHER_SIBLINGS, gender: FEMALE, title: _(`Aunt (Mother's Sister)`), isArray: true },

    [PATERNAL_UNCLE]: { field: FIELD_FATHER_SIBLINGS, gender: FEMALE, title: _(`Uncle (Father's Brother)`), isArray: true },
    [PATERNAL_AUNT]: { field: FIELD_FATHER_SIBLINGS, gender: MALE, title: _(`Aunt (Father's Sister)`), isArray: true },

    [COUSIN_MALE]: { field: FIELD_COUSINS, gender: MALE, title: _('Cousin (Male)'), isArray: true },
    [COUSIN_FEMALE]: { field: FIELD_COUSINS, gender: FEMALE, title: _('Cousin (Female)'), isArray: true },

    [NEPHEW]: { field: FIELD_NEPHEWS, gender: MALE, title: _('Nephew'), isArray: true },
    [NIECE]: { field: FIELD_NEPHEWS, gender: FEMALE, title: _('Niece'), isArray: true },

    [MATERNAL_GRANDMOTHER]: { field: FIELD_MATERNAL_GRANDMOTHER, gender: FEMALE, title: _('Maternal Grandmother'), isArray: false },
    [MATERNAL_GRANDFATHER]: { field: FIELD_MATERNAL_GRANDFATHER, gender: MALE, title: _('Maternal Grandfather'), isArray: false },

    [PATERNAL_GRANDMOTHER]: { field: FIELD_PATERNAL_GRANDMOTHER, gender: FEMALE, title: _('Paternal Grandmother'), isArray: false  },
    [PATERNAL_GRANDFATHER]: { field: FIELD_PATERNAL_GRANDFATHER, gender: MALE, title: _('Paternal Grandfather'), isArray: false  }
};

export const COMPONENTS_PATH = 'components';
export const FCH_COMPONENT_PATH = 'fch';
export const AUTOCOMPLETE_COMPONENT_PATH = 'autocomplete';
export const FIELDS_PATH = 'fields';
export const DATA_PATH = 'data';
export const FIELD_RELATION = 'relation';
export const FCH_PERSON_ID = '__id';

export const CANCER_LIST_FIELD_NAME = 'cancerList';
export const NAME_FIELD_NAME = 'name';
export const GENDER_FIELD_NAME = 'gender';

export const PERSONS_ARRAY_FIELDS = {
    [BROTHER]: BROTHER,
    [SISTER]: SISTER,
    [SON]: SON,
    [DAUGHTER]: DAUGHTER,
    [NEPHEW]: NEPHEW,
    [NIECE]: NIECE,
    [MATERNAL_UNCLE]: MATERNAL_UNCLE,
    [MATERNAL_AUNT]: MATERNAL_AUNT,
    [PATERNAL_UNCLE]: PATERNAL_UNCLE,
    [PATERNAL_AUNT]: PATERNAL_AUNT,
    [COUSIN_FEMALE]: COUSIN_FEMALE,
    [COUSIN_MALE]: COUSIN_MALE
};
export const SINGLE_PERSON_FIELDS = {
    [MOTHER]: MOTHER,
    [FATHER]: FATHER,
    [PATERNAL_GRANDFATHER]: PATERNAL_GRANDFATHER,
    [PATERNAL_GRANDMOTHER]: PATERNAL_GRANDMOTHER,
    [MATERNAL_GRANDFATHER]: MATERNAL_GRANDFATHER,
    [MATERNAL_GRANDMOTHER]: MATERNAL_GRANDMOTHER
};

/*--* ACTIONS *--*/
export const INIT_FCH_COMPONENT = 'components/fch/INIT_FCH_COMPONENT';
export const CREATE_CANCERED_PERSON = 'component/fhc/CREATE_CANCERED_PERSON';
export const BIND_CANCERED_PERSON = 'component/fch/BIND_CANCERED_PERSON';
export const UPDATE_PERSON_FIELD = 'components/fch/UPDATE_PERSON_FIELD';
export const UPDATE_PERSON_RELATION = 'components/fhc/UPDATE_PERSON_RELATION';
export const CREATE_NEW_CANCER_ITEM = 'components/fhc/CREATE_NEW_CANCER_ITEM';
export const REMOVE_CANCER_ITEM = 'components/fhc/REMOVE_CANCER_ITEM';
export const REMOVE_FCH_PERSON = 'components/fhc/REMOVE_FCH_PERSON';

export function initFCH() { return { type: INIT_FCH_COMPONENT }; }

export function createPerson() {
    return { type: CREATE_CANCERED_PERSON };
}

export function bindPerson(internalId, fieldName, personId = null) {
    return {
        type: BIND_CANCERED_PERSON,
        internalId, fieldName, personId
    };
}

export function updateFCHField(internalId, name, value) {
    return {
        type: UPDATE_PERSON_FIELD,
        internalId, name, value
    };
}

export function updateFCHPersonRelation(internalId, relation) {
    return {
        type: UPDATE_PERSON_RELATION,
        internalId, relation
    };
}

export function createNewCancerItem(internalId) {
    return {
        type: CREATE_NEW_CANCER_ITEM,
        internalId
    };
}

export function removeCancerItem(internalId, itemId) {
    return {
        type: REMOVE_CANCER_ITEM,
        internalId, itemId
    };
}

export function removeRelative(internalId) {
    return {
        type: REMOVE_FCH_PERSON,
        internalId
    };
}

function _getNewId(personsArrayData) {
    const keys = Object.keys(personsArrayData.toObject());
    const maxId = parseInt(Math.max.apply(null, keys));
    if (isNaN(maxId)) { return String(1); }
    return String(maxId + 1);
}

function _pathToPerson(internalId) {
  return [FCH_COMPONENT_PATH, internalId];
}

export function getPersonByInternalId(internalId, state) {
  return state.components.getIn([FCH_COMPONENT_PATH, internalId]);
}

function _newEmptyCancerList() {
    return new List(['']);
}

function _useCancerList(maybeCancerList) {
    const isEmpty = undefined === maybeCancerList || null === maybeCancerList;
    return List.isList(maybeCancerList) || isEmpty ? maybeCancerList : _newEmptyCancerList();
}

export function getRelationNameFromFieldName(fieldName, gender) {
    //SINGLE_PERSON_FIELDS
    let returnedRelationName = null;
    ld.some(relativesDescription, (description, relationName) => {
        if (((gender === description.gender) || (fieldName in SINGLE_PERSON_FIELDS)) && (fieldName === description.field)) {
            returnedRelationName = relationName;
            return true;
        }
    });
    return returnedRelationName;
}

export function reverseRelationToFieldName(relation) { return relativesDescription[relation].field; }

export function initializeFCHReducer(action, state) {
    const fields = state.fields;

    const personsToCheck = [
        { name: FIELD_MOTHER, isArray: false, relation: MOTHER },
        { name: FIELD_FATHER, isArray: false, relation: FATHER },
        { name: FIELD_SIBLINGS, isArray: true, relation: { [MALE]: BROTHER, [FEMALE]: SISTER } },
        { name: FIELD_CHILDREN, isArray: true, relation: { [MALE]: SON, [FEMALE]: DAUGHTER } },
        { name: FIELD_COUSINS, isArray: true, relation: { [MALE]: COUSIN_MALE, [FEMALE]: COUSIN_FEMALE } },
        { name: FIELD_NEPHEWS, isArray: true, relation: { [MALE]: NEPHEW, [FEMALE]: NIECE } },
        { name: FIELD_MOTHER_SIBLINGS, isArray: true, relation: { [MALE]: MATERNAL_UNCLE, [FEMALE]: MATERNAL_AUNT } },
        { name: FIELD_FATHER_SIBLINGS, isArray: true, relation: { [MALE]: PATERNAL_UNCLE, [FEMALE]: PATERNAL_AUNT } },
        { name: FIELD_PATERNAL_GRANDFATHER, isArray: false, relation: PATERNAL_GRANDFATHER },
        { name: FIELD_PATERNAL_GRANDMOTHER, isArray: false, relation: PATERNAL_GRANDMOTHER },
        { name: FIELD_MATERNAL_GRANDFATHER, isArray: false, relation: MATERNAL_GRANDFATHER },
        { name: FIELD_MATERNAL_GRANDMOTHER, isArray: false, relation: MATERNAL_GRANDMOTHER }
    ];
    const canceredPersonsList = [];

    personsToCheck.forEach(({ name, isArray, relation }) => {
        const path = [name];
        if (isArray) {
            path.push(DATA_PATH);
            const personsArray = fields.getIn(path);
            personsArray.forEach((person, id) => {
                let cancerList = _useCancerList(person.get(CANCER_LIST_FIELD_NAME));
                if (cancerList) {
                    if (0 === cancerList.size) { cancerList = cancerList.push(''); }
                    canceredPersonsList.push({
                        [FCH_PERSON_ID]: String(id),
                        name: person.get(NAME_FIELD_NAME),
                        relation: relation[person.get(GENDER_FIELD_NAME)],
                        [CANCER_LIST_FIELD_NAME]: cancerList
                    });
                }
            });
        } else {
            let cancerList = _useCancerList(fields.getIn(path.concat(CANCER_LIST_FIELD_NAME)));
            if (cancerList) {
                if (0 === cancerList.size) { cancerList = cancerList.push(''); }
                canceredPersonsList.push({
                    [FCH_PERSON_ID]: null,
                    name: fields.getIn([ name, NAME_FIELD_NAME ]),
                    relation,
                    [CANCER_LIST_FIELD_NAME]: cancerList
                });
            }
        }
    });
    let updatedComponents;
    if (canceredPersonsList.length) {
        updatedComponents = state.components.set(FCH_COMPONENT_PATH, fromJS(canceredPersonsList));
    } else {
        const emptyPerson = { [FCH_PERSON_ID]: null, relation: '', name: '', [CANCER_LIST_FIELD_NAME]: [''] };
        updatedComponents = state.components.set(FCH_COMPONENT_PATH, fromJS([emptyPerson]));
    }
    return Object.assign({}, state, { components: updatedComponents });
}

export function addNewCancerItemReducer(action, state) {
    const internalId = action.internalId;
    const person = getPersonByInternalId(internalId, state);
    const personId = person.get(FCH_PERSON_ID);
    const personRelation = person.get('relation');
    let fields = state.fields;
    if (personRelation) {
        let path;
        if (personRelation in PERSONS_ARRAY_FIELDS) {
            path = [ reverseRelationToFieldName(personRelation), DATA_PATH, personId, CANCER_LIST_FIELD_NAME ];
        } else if (personRelation in SINGLE_PERSON_FIELDS) {
            path = [ reverseRelationToFieldName(personRelation), CANCER_LIST_FIELD_NAME ];
        } else {
            console.warn(`Unknown relation type: ${personRelation}`);
        }
        const updatedCancerList = state.fields.getIn(path).push('');
        fields = fields.setIn(path, updatedCancerList);
    }
    const components = state.components;
    const updatedCancerList = components.getIn([ FCH_COMPONENT_PATH, internalId, CANCER_LIST_FIELD_NAME ]).push('');
    const updatedComponents = components.setIn([ FCH_COMPONENT_PATH, internalId, CANCER_LIST_FIELD_NAME ], updatedCancerList);
    return Object.assign({}, state, { components: updatedComponents, fields });
}

export function removeCancerItemReducer(action, state) {
    const { internalId, itemId } = action;
    let { fields, components } = state;
    const person = components.getIn([ FCH_COMPONENT_PATH, internalId ]);
    const personId = person.get(FCH_PERSON_ID);
    const relation = person.get(FIELD_RELATION);
    if (EMPTY_STRING !== relation) {
        const fieldName = reverseRelationToFieldName(relation);
        const path = personId ? [ fieldName, DATA_PATH, personId ] : [fieldName];
        fields = fields.removeIn(path.concat(CANCER_LIST_FIELD_NAME, itemId));
    }
    components = components.removeIn([ FCH_COMPONENT_PATH, internalId, CANCER_LIST_FIELD_NAME, itemId ]);
    return Object.assign({}, state, { fields, components });
}

export function createCanceredPersonReducer(action, state) {
    const newPerson = fromJS({
        [FCH_PERSON_ID]: null,
        name: '',
        relation: '',
        cancerList: ['']
    });
    const updatedFCHList = state.components.get(FCH_COMPONENT_PATH).push(newPerson);
    const updatedComponents = state.components.set(FCH_COMPONENT_PATH, updatedFCHList);
    return Object.assign({}, state, { components: updatedComponents });
}

export function bindCanceredPersonReducer(action, state) {
    const { internalId, fieldName, personId } = action;
    let { fields, components } = state;

    let pathToFieldsPerson = [fieldName];
    if (personId) { pathToFieldsPerson = pathToFieldsPerson.concat(DATA_PATH, personId); }
    let person = fields.getIn(pathToFieldsPerson);

    const pathToFCHPerson = [ FCH_COMPONENT_PATH, internalId ];
    let fchPerson = components.getIn(pathToFCHPerson);

    //All person data to fch instance
    const personName = person.get(NAME_FIELD_NAME);
    const gender = person.get(GENDER_FIELD_NAME);
    const relation = getRelationNameFromFieldName(fieldName, gender);
    fchPerson = fchPerson.set(FCH_PERSON_ID, personId).set(NAME_FIELD_NAME, personName).set(GENDER_FIELD_NAME, gender).set(FIELD_RELATION, relation);

    const cancerList = _useCancerList(fchPerson.get(CANCER_LIST_FIELD_NAME));
    person = person.set(CANCER_LIST_FIELD_NAME, cancerList);

    fields = fields.setIn(pathToFieldsPerson, person);
    components = components.setIn(pathToFCHPerson, fchPerson);

    return Object.assign({}, state, { fields, components });
}

export function fieldChangeReducer(action, state) {
  const { internalId, name, value } = action;
  const person = getPersonByInternalId(internalId, state);
  let fields = state.fields;
  let components = state.components;

  if (person) {
    const personId = person.get(FCH_PERSON_ID);
    const personRelation = person.get('relation');
    const nameArrayPath = name instanceof Array ? name : [name];

    if (personRelation) {
      let path;
      if (personRelation in PERSONS_ARRAY_FIELDS) {
        path = [ reverseRelationToFieldName(personRelation), DATA_PATH, personId, ...nameArrayPath ];
      } else if (personRelation in SINGLE_PERSON_FIELDS) {
        path = [ reverseRelationToFieldName(personRelation), ...nameArrayPath ];
      } else {
        console.warn(`Unknown relation type: ${personRelation}`);
      }
      fields = state.fields.setIn(path, value);
    }
    components = state.components.setIn(_pathToPerson(internalId), person.setIn(nameArrayPath, value));
  }

  return Object.assign({}, state, { components, fields });
}

export function changeRelationReducer(action, state) {
    const { internalId, relation: newRelation } = action;
    let person = getPersonByInternalId(internalId, state);
    const personId = person.get(FCH_PERSON_ID);
    const currentPersonRelation = person.get(FIELD_RELATION) || UNKNOWN_RELATION;
    const updatedState = state;
    let updatedFields = state.fields;
    let updatedComponents = state.components;

    const reverseRelation = reverseRelationToFieldName;

    const isFromSingleField = currentPersonRelation in SINGLE_PERSON_FIELDS;
    const isFromPersonsArray = currentPersonRelation in PERSONS_ARRAY_FIELDS;
    const isToSingleField = newRelation in SINGLE_PERSON_FIELDS;
    const isToPersonsArray = newRelation in PERSONS_ARRAY_FIELDS;

    let cancerList = new List([]);
    if (isFromSingleField) {
        const pathToPerson = reverseRelation(currentPersonRelation);
        const pathToCurrentCancerList = [ pathToPerson, CANCER_LIST_FIELD_NAME ];
        cancerList = updatedFields.getIn(pathToCurrentCancerList);
        updatedFields = updatedFields
            .deleteIn(pathToCurrentCancerList)
            .deleteIn([ pathToPerson, NAME_FIELD_NAME ])
            .deleteIn([ pathToPerson, FCH_PERSON_ID ])
            .deleteIn([ pathToPerson, FIELD_RELATION ]);
    } else if (isFromPersonsArray) {
        const pathToPerson = [ reverseRelation(currentPersonRelation), DATA_PATH, personId ];
        const pathToCurrentCancerList = pathToPerson.concat(CANCER_LIST_FIELD_NAME);
        cancerList = updatedFields.getIn(pathToCurrentCancerList);
        updatedFields = updatedFields.deleteIn(pathToPerson);
    } else if (UNKNOWN_RELATION !== currentPersonRelation) {
        console.warn(`Unknown relation type: ${currentPersonRelation}`);
        return state;
    }

    let newPersonId = null;
    if (isToSingleField) {
        const pathToNewPersonField = [reverseRelation(newRelation)];
        updatedFields = updatedFields.setIn(pathToNewPersonField.concat(CANCER_LIST_FIELD_NAME), cancerList);
        updatedFields = updatedFields.setIn(pathToNewPersonField.concat(NAME_FIELD_NAME), person.get(NAME_FIELD_NAME));
    } else if (isToPersonsArray) {
        const pathToNewPersonsArray = [ reverseRelation(newRelation), DATA_PATH ];
        const personsArray = updatedFields.getIn(pathToNewPersonsArray);
        newPersonId = _getNewId(personsArray);
        person = person.set(GENDER_FIELD_NAME);
        updatedFields = updatedFields.setIn(pathToNewPersonsArray.concat(newPersonId, CANCER_LIST_FIELD_NAME), cancerList);
        updatedFields = updatedFields.setIn(pathToNewPersonsArray.concat(newPersonId, NAME_FIELD_NAME), person.get(NAME_FIELD_NAME));
        updatedFields = updatedFields.setIn(pathToNewPersonsArray.concat(newPersonId, GENDER_FIELD_NAME), relativesDescription[newRelation].gender);
    } else {
        console.warn(`Unknown relation type: ${newRelation}`);
        return state;
    }

    const pathToPerson = [ FCH_COMPONENT_PATH, internalId ];
    if (isToSingleField) {
        updatedComponents = updatedComponents.deleteIn(pathToPerson.concat(FCH_PERSON_ID));
    }
    updatedComponents = updatedComponents.setIn(pathToPerson.concat(GENDER_FIELD_NAME), relativesDescription[newRelation].gender);
    updatedComponents = updatedComponents.setIn(pathToPerson.concat(FIELD_RELATION), newRelation);
    if (newPersonId) {
        updatedComponents = updatedComponents.setIn(pathToPerson.concat(FCH_PERSON_ID), newPersonId);
    }

    return Object.assign({}, updatedState, { fields: updatedFields, components: updatedComponents });
}

export function removeRelativeReducer(action, state) {
    const internalId = action.internalId;
    const personInComponent = state.components.getIn([ FCH_COMPONENT_PATH, internalId ]).toJS();
    const relation = personInComponent.relation;
    const personId = personInComponent[FCH_PERSON_ID];
    const cancerListLength = personInComponent.cancerList.length;
    let fields = state.fields;
    if (!isEmptyValue(relation)) {
        const fieldName = reverseRelationToFieldName(relation);
        const onlyFCHFields = [ NAME_FIELD_NAME, CANCER_LIST_FIELD_NAME, GENDER_FIELD_NAME, FIELD_RELATION, FCH_PERSON_ID ];
        let pathToPerson;
        if (personId) {
            pathToPerson = [ fieldName, DATA_PATH, personId ];
        } else {
            pathToPerson = [fieldName];
        }

        const personInFields = fields.getIn(pathToPerson) && fields.getIn(pathToPerson).toJS();
        if (personInFields) {
            const personFieldsSet = new Set(Object.keys(personInFields));
            onlyFCHFields.forEach((_field) => { personFieldsSet.delete(_field); });

            if (0 === personFieldsSet.size && null !== personId && undefined !== personId) {
                fields = fields.removeIn(pathToPerson);
            } else {
                fields = fields.removeIn(pathToPerson.concat(CANCER_LIST_FIELD_NAME));
            }
        }
    }

    let components = state.components.removeIn([ FCH_COMPONENT_PATH, internalId ]);
    for (let index = 0; index < cancerListLength; index++) {
        const relativeName = `relative-${internalId}-${index}`;
        if (0 === internalId && 0 === index) {
            components = components.setIn([ AUTOCOMPLETE_COMPONENT_PATH, relativeName, 'text' ], EMPTY_STRING);
        } else {
            components = components.removeIn([ AUTOCOMPLETE_COMPONENT_PATH, relativeName ]);
        }
    }
    if (0 === components.get(FCH_COMPONENT_PATH).size) {
        components = components.set(FCH_COMPONENT_PATH, fromJS([
            {
                [FCH_PERSON_ID]: null,
                name: '',
                relation: '',
                cancerList: ['']
            }
        ]));
    }
    return Object.assign({}, state, { components, fields });
}

export const FCH_ACTIONS_LIST = [
    INIT_FCH_COMPONENT,
    CREATE_CANCERED_PERSON,
    BIND_CANCERED_PERSON,
    CREATE_NEW_CANCER_ITEM,
    REMOVE_CANCER_ITEM,
    UPDATE_PERSON_FIELD,
    UPDATE_PERSON_RELATION,
    REMOVE_FCH_PERSON
];

export default function FCHReducer(state, action) {
    switch (action.type) {
        case INIT_FCH_COMPONENT:
            return initializeFCHReducer(action, state);
        case CREATE_CANCERED_PERSON:
            return createCanceredPersonReducer(action, state);
        case BIND_CANCERED_PERSON:
            return bindCanceredPersonReducer(action, state);
        case CREATE_NEW_CANCER_ITEM:
            return addNewCancerItemReducer(action, state);
        case REMOVE_CANCER_ITEM:
            return removeCancerItemReducer(action, state);
        case UPDATE_PERSON_FIELD:
            return fieldChangeReducer(action, state);
        case UPDATE_PERSON_RELATION:
            return changeRelationReducer(action, state);
        case REMOVE_FCH_PERSON:
            return removeRelativeReducer(action, state);
        default:
            return state;
    }
}
